import { useState, useEffect } from 'react';

import{ClockIcon,TruckIcon,CashIcon,CardIcon,ResetIcon,CheckIcon} from '../Icons/icons'
import HeurePicker from './HeurePicker';



// ── Vue Entrée Camion ──────────────────────────────────
export default function VueEntree({ onSuccess }) {
  const [plaque,     setPlaque]     = useState('');
  const [reglement,  setReglement]  = useState('especes');
  const [heureDepart,setHeureDepart]= useState('');
  const [heureEntree,setHeureEntree]= useState('');

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      const h = String(now.getHours()).padStart(2,'0');
      const m = String(now.getMinutes()).padStart(2,'0');
      const d = now.toLocaleDateString('fr-FR', { day:'2-digit', month:'2-digit', year:'numeric' });
      setHeureEntree(`${h}:${m} — ${d}`);
    };
    tick();
    const id = setInterval(tick, 30000);
    return () => clearInterval(id);
  }, []);

  const handleReset = () => {
    setPlaque(''); setReglement('especes'); setHeureDepart('');
  };

  const handleSubmit = () => {
    if (!plaque.trim() || !heureDepart) {
      alert('Veuillez remplir la plaque et l\'heure de départ.');
      return;
    }
    // TODO: axios.post('/api/camions/entree', { plaque, reglement, heureDepart })
    onSuccess?.({ plaque, reglement, heureDepart });
    handleReset();
  };

  return (
    <>
      <div className="vv-page-header">
        <div>
          <div className="vv-page-title">Entrée camion</div>
          <div className="vv-page-sub">Enregistrement nouvelle arrivée</div>
        </div>
      </div>

      <div className="vv-content">
        <div className="vv-panel">
          <div className="vv-panel-title">
            <TruckIcon /> Nouvelle entrée
          </div>

          <div className="vv-form-grid">

            {/* Plaque */}
            <div className="vv-form-full">
              <label className="vv-field-label">Plaque d'immatriculation *</label>
              <input
                className="vv-input plaque"
                type="text"
                placeholder="Ex: 12 TUN 2024"
                value={plaque}
                onChange={e => setPlaque(e.target.value.toUpperCase())}
              />
            </div>

            {/* Règlement */}
            <div>
              <label className="vv-field-label">Mode de règlement *</label>
              <div className="vv-reglement-grid">
                <button
                  className={`vv-reglement-btn${reglement === 'especes' ? ' active' : ''}`}
                  onClick={() => setReglement('especes')}
                >
                  <CashIcon /> Espèces
                </button>
                <button
                  className={`vv-reglement-btn${reglement === 'cb' ? ' active' : ''}`}
                  onClick={() => setReglement('cb')}
                >
                  <CardIcon /> CB
                </button>
              </div>
            </div>

            {/* Heure départ */}
            <div>
              <label className="vv-field-label">Heure de départ estimée *</label>
              <HeurePicker value={heureDepart} onChange={setHeureDepart} />
            </div>

            {/* Heure entrée auto */}
            <div>
              <label className="vv-field-label">Heure d'entrée (auto)</label>
              <input className="vv-input" type="text" value={heureEntree} readOnly disabled />
            </div>

            {/* Veilleur auto */}
            <div>
              <label className="vv-field-label">Veilleur</label>
              <input className="vv-input" type="text" value="Karim Amara" readOnly disabled />
            </div>

          </div>

          <div className="vv-form-actions">
            <button className="vv-btn vv-btn-ghost" onClick={handleReset}>
              <ResetIcon /> Réinitialiser
            </button>
            <button className="vv-btn vv-btn-primary" onClick={handleSubmit}>
              <CheckIcon /> Valider l'entrée
            </button>
     


    
      
 
          </div>
        </div>
      </div>
    </>
  );
}